const styles = (theme) => ({
  addProPaperAnchor: {
    width: 446,
    zIndex: 1000,
    position: 'absolute',
    background: theme.ModalBGColor,
    top: 55,
    bottom: 10,
    height: 'fill-available',
    '@supports (-moz-available)': { height: '-moz-available' },
    '@supports (-webkit-fill-available)': { height: '-webkit-fill-available' }
  }
});

export default styles;
